import { inject, Injectable } from '@angular/core';
import { MessageService } from 'primeng/api';

//this service contains methods that allows notifications or 'toasts' to be displayed in the UI
//https://primeng.org/toast
@Injectable({
	providedIn: 'root',
})
export class ToastService {
	private messageService = inject<MessageService>(MessageService);

	//shows error toast. sticky optional param toggles if the notification will stay on the screen
	public showErrorToast(message: string, sticky = false): void {
		this.messageService.add({
			severity: 'error',
			summary: 'Error',
			detail: message,
			sticky: sticky,
		});
	}

	//shows success toast
	public showSuccessToast(message: string): void {
		this.messageService.add({
			severity: 'success',
			summary: 'Success',
			detail: message,
		});
	}

	//shows loading toast
	public showLoadingToast(message: string, sticky = false): void {
		this.messageService.add({
			key: 'sticky-toast',
			severity: 'info',
			summary: 'Loading',
			detail: message,
			sticky: sticky,
			icon: 'pi pi-spin pi-spinner',
		});
	}

	//clears sticky toasts or toasts that require the 'x' to be clicked
	public clearStickyToasts(): void {
		this.messageService.clear('sticky-toast');
	}
}
